import BeneficiarioApi from './BeneficiarioApi';
import CarenciaApi from './CarenciaApi';
import ChangelogApi from './ChangelogApi';
import VersaoSistemaApi from './VersaoSistemaApi';
import CreditoApi from './CreditoApi';
import LoginApi from './LoginApi';
import ParametroApi from './ParametroApi';
import ExtratoApi from './ExtratoApi';
import PrestadorApi from './PrestadorApi';
import AnexoApi from './AnexoApi';
import ArquivoXMLApi from './ArquivoXMLApi';
import FaturaApi from './FaturaApi';
import GuiaApi from './GuiaApi';
import TipoAtendimentoApi from './TipoAtendimentoApi';
import ElementoApi from './ElementoApi';
import UsuarioApi from './UsuarioApi';
import TipoSituacaoServidorApi from './TipoSituacaoServidorApi';
import DividasEmAbertoApi from './DividasEmAbertoApi';
import GlosaApi from './GlosaApi';
import CepApi from './CepApi';
import TelefoneApi from './TelefoneApi';
import OrgaoExternoApi from './OrgaoExternoApi';
import BancoApi from './BancoApi';
import AgenciaApi from './AgenciaApi';
import ProcessoApi from './ProcessoApi';
import ContratoApi from './ContratoApi';
import DemonstrativoApi from './DemonstrativoApi';
import ProdutividadeApi from './ProdutividadeApi';
import ProfissionalApi from './ProfissionalApi';
import UfApi from './UfApi';
import FaixaRemuneracaoApi from './FaixaRemuneracaoApi';
import FaixaEtariaApi from './FaixaEtariaApi';
import TipoMensalidadeApi from './TipoMensalidadeApi';
import MensalidadeApi from './MensalidadeApi';
import LimiteCobrancaApi from './LimiteCobrancaApi';
import CalculoCoparticipacaoApi from './CalculoCoparticipacaoApi';
import PensionistaApi from './PensionistaApi';
import AcertoMensalidadeApi from './AcertoMensalidadeApi';
import AcertoCoparticipacaoApi from './AcertoCoparticipacaoApi';
import ItemTabelaApi from './ItemTabelaApi';
import DividaServDesligadoApi from './DividaServDesligadoApi';
import DividaServDesligadoPagtoApi from './DividaServDesligadoPagtoApi';
import CalculoAtuarialApi from './CalculoAtuarialApi';
import AcertosDiversosApi from './AcertosDiversosApi';
import RelatorioBeneficiariosApi from './RelatorioBeneficiariosApi';
import DeclaracaoDeGastosApi from './DeclaracaoDeGastosApi';
import ReembolsoMedicoApi from './ReembolsoMedicoApi';
import AssistenciaOdontoApi from './AssistenciaOdontoApi';
import RelatorioReembolsoApi from './RelatorioReembolsoApi';
import VigenciaPorteApi from './VigenciaPorteApi';

export default class ApiFactory {
  static _instance;

  _usuarioSso;
  _loginApi;
  _changelogApi;
  _versaoSistemaApi;
  _beneficiarioApi;
  _parametroApi;
  _creditoApi;
  _carenciaApi;
  _extratoApi;
  _prestadorApi;
  _anexoApi;
  _arquivoXMLApi;
  _faturaApi;
  _guiaApi;
  _tipoAtendimentoApi;
  _tipoSituacaoServidorApi;
  _dividasEmAbertoApi;
  _elementoApi;
  _usuarioApi
  _glosaApi
  _cepApi
  _telefoneApi
  _orgaoExternoApi
  _bancoApi
  _agenciaApi
  _processoApi
  _contratoApi
  _demonstrativoApi
  _produtividadeApi
  _profissionalApi
  _ufApi
  _faixaRemuneracaoApi
  _faixaEtariaApi
  _tipoMensalidadeApi
  _mensalidadeApi
  _limiteCobrancaApi
  _calculoCoparticipacao
  _pensionistaApi
  _acertoMensalidadeApi
  _acertoCoparticipacaoApi
  _acertosDiversosApi
  _itemTabelaApi
  _dividaServDesligadoApi
  _dividaServDesligadoPagtoApi
  _calculoAtuarialApi
  _relatorioBeneficiariosApi
  _declaracaoDeGastosApi
  _reembolsoMedicoApi
  _assistenciaOdontoApi
  _relatorioReembolsoApi
  _vigenciaPorteApi

  constructor (usuarioSso) {
    this._usuarioSso = usuarioSso;
  }

  static getInstance () {
    if (!ApiFactory._instance) {
      ApiFactory._instance = new ApiFactory();
    }
    return ApiFactory._instance;
  }

  static reset (usuarioSso) {
    ApiFactory._instance = new ApiFactory(usuarioSso);
  }

  getLoginApi () {
    if (!this._loginApi) {
      this._loginApi = new LoginApi(this._usuarioSso);
    }
    return this._loginApi;
  }

  getChangelogApi () {
    if (!this._changelogApi) {
      this._changelogApi = new ChangelogApi(this._usuarioSso);
    }
    return this._changelogApi;
  }

  getVersaoSistemaApi () {
    if (!this._versaoSistemaApi) {
      this._versaoSistemaApi = new VersaoSistemaApi(this._usuarioSso);
    }
    return this._versaoSistemaApi;
  }

  getBeneficiarioApi () {
    if (!this._beneficiarioApi) {
      this._beneficiarioApi = new BeneficiarioApi(this._usuarioSso);
    }
    return this._beneficiarioApi;
  }

  getParametroApi () {
    if (!this._parametroApi) {
      this._parametroApi = new ParametroApi(this._usuarioSso);
    }
    return this._parametroApi;
  }

  getCreditoApi () {
    if (!this._creditoApi) {
      this._creditoApi = new CreditoApi(this._usuarioSso);
    }
    return this._creditoApi;
  }
  getCarenciaApi () {
    if (!this._carenciaApi) {
      this._carenciaApi = new CarenciaApi(this._usuarioSso);
    }
    return this._carenciaApi;
  }
  getExtratoApi () {
    if (!this._extratoApi) {
      this._extratoApi = new ExtratoApi(this._usuarioSso);
    }
    return this._extratoApi;
  }
  getPrestadorApi () {
    if (!this._prestadorApi) {
      this._prestadorApi = new PrestadorApi(this._usuarioSso);
    }
    return this._prestadorApi;
  }

  getAnexoApi () {
    if (!this._anexoApi) {
      this._anexoApi = new AnexoApi(this._usuarioSso);
    }
    return this._anexoApi;
  }

  getArquivoXMLApi () {
    if (!this._arquivoXMLApi) {
      this._arquivoXMLApi = new ArquivoXMLApi(this._usuarioSso);
    }
    return this._arquivoXMLApi;
  }

  getFaturaApi () {
    if (!this._faturaApi) {
      this._faturaApi = new FaturaApi(this._usuarioSso);
    }
    return this._faturaApi;
  }

  getGuiaApi () {
    if (!this._guiaApi) {
      this._guiaApi = new GuiaApi(this._usuarioSso);
    }
    return this._guiaApi;
  }

  getTipoAtendimentoApi () {
    if (!this._tipoAtendimentoApi) {
      this._tipoAtendimentoApi = new TipoAtendimentoApi(this._usuarioSso);
    }
    return this._tipoAtendimentoApi;
  }
  getTipoSituacaoServidorApi () {
    if (!this._tipoSituacaoServidorApi) {
      this._tipoSituacaoServidorApi = new TipoSituacaoServidorApi(this._usuarioSso);
    }
    return this._tipoSituacaoServidorApi;
  }
  getDividasEmAbertoApi () {
    if (!this._dividasEmAbertoApi) {
      this._dividasEmAbertoApi = new DividasEmAbertoApi(this._usuarioSso);
    }
    return this._dividasEmAbertoApi;
  }
  getElementoApi () {
    if (!this._elementoApi) {
      this._elementoApi = new ElementoApi(this._usuarioSso);
    }
    return this._elementoApi;
  }
  getUsuarioApi () {
    if (!this._usuarioApi) {
      this._usuarioApi = new UsuarioApi(this._usuarioSso);
    }
    return this._usuarioApi;
  }
  getGlosaApi () {
    if (!this._glosaApi) {
      this._glosaApi = new GlosaApi(this._usuarioSso);
    }
    return this._glosaApi;
  }
  getCepApi () {
    if (!this._cepApi) {
      this._cepApi = new CepApi(this._usuarioSso);
    }
    return this._cepApi;
  }
  getTelefoneApi () {
    if (!this._telefoneApi) {
      this._telefoneApi = new TelefoneApi(this._usuarioSso);
    }
    return this._telefoneApi;
  }
  getOrgaoExternoApi () {
    if (!this._orgaoExternoApi) {
      this._orgaoExternoApi = new OrgaoExternoApi(this._usuarioSso);
    }
    return this._orgaoExternoApi;
  }
  getBancoApi () {
    if (!this._bancoApi) {
      this._bancoApi = new BancoApi(this._usuarioSso);
    }
    return this._bancoApi;
  }
  getAgenciaApi () {
    if (!this._agenciaApi) {
      this._agenciaApi = new AgenciaApi(this._usuarioSso);
    }
    return this._agenciaApi;
  }
  getProcessoApi () {
    if (!this._processoApi) {
      this._processoApi = new ProcessoApi(this._usuarioSso);
    }
    return this._processoApi;
  }
  getContratoApi () {
    if (!this._contratoApi) {
      this._contratoApi = new ContratoApi(this._usuarioSso);
    }
    return this._contratoApi;
  }
  getDemonstrativoApi () {
    if (!this._demonstrativoApi) {
      this._demonstrativoApi = new DemonstrativoApi(this._usuarioSso);
    }
    return this._demonstrativoApi;
  }
  getProdutividadeApi () {
    if (!this._produtividadeApi) {
      this._produtividadeApi = new ProdutividadeApi(this._usuarioSso);
    }
    return this._produtividadeApi;
  }
  getProfissionalApi () {
    if (!this._profissionalApi) {
      this._profissionalApi = new ProfissionalApi(this._usuarioSso);
    }
    return this._profissionalApi;
  }
  getUfApi () {
    if (!this._ufApi) {
      this._ufApi = new UfApi(this._usuarioSso);
    }
    return this._ufApi;
  }
  getFaixaRemuneracaoApi () {
    if (!this._faixaRemuneracaoApi) {
      this._faixaRemuneracaoApi = new FaixaRemuneracaoApi(this._usuarioSso);
    }
    return this._faixaRemuneracaoApi;
  }
  getFaixaEtariaApi () {
    if (!this._faixaEtariaApi) {
      this._faixaEtariaApi = new FaixaEtariaApi(this._usuarioSso);
    }
    return this._faixaEtariaApi;
  }
  getTipoMensalidadeApi () {
    if (!this._tipoMensalidadeApi) {
      this._tipoMensalidadeApi = new TipoMensalidadeApi(this._usuarioSso);
    }
    return this._tipoMensalidadeApi;
  }
  getMensalidadeApi () {
    if (!this._mensalidadeApi) {
      this._mensalidadeApi = new MensalidadeApi(this._usuarioSso);
    }
    return this._mensalidadeApi;
  }
  getLimiteCobrancaApi () {
    if (!this._limiteCobrancaApi) {
      this._limiteCobrancaApi = new LimiteCobrancaApi(this._usuarioSso);
    }
    return this._limiteCobrancaApi;
  }
  getCalculoCoparticipacaoApi () {
    if (!this._calculoCoparticipacao) {
      this._calculoCoparticipacao = new CalculoCoparticipacaoApi(this._usuarioSso);
    }
    return this._calculoCoparticipacao;
  }
  getPensionistaApi () {
    if (!this._pensionistaApi) {
      this._pensionistaApi = new PensionistaApi(this._usuarioSso);
    }
    return this._pensionistaApi;
  }
  getAcertoMensalidadeApi () {
    if (!this._acertoMensalidadeApi) {
      this._acertoMensalidadeApi = new AcertoMensalidadeApi(this._usuarioSso);
    }
    return this._acertoMensalidadeApi;
  }
  getAcertoCoparticipacaoApi () {
    if (!this._acertoCoparticipacaoApi) {
      this._acertoCoparticipacaoApi = new AcertoCoparticipacaoApi(this._usuarioSso);
    }
    return this._acertoCoparticipacaoApi;
  }
  getAcertosDiversosApi () {
    if (!this._acertosDiversosApi) {
      this._acertosDiversosApi = new AcertosDiversosApi(this._usuarioSso);
    }
    return this._acertosDiversosApi;
  }
  getItemTabelaApi () {
    if (!this._itemTabelaApi) {
      this._itemTabelaApi = new ItemTabelaApi(this._usuarioSso);
    }
    return this._itemTabelaApi;
  }
  getDividaServDesligadoApi () {
    if (!this._dividaServDesligadoApi) {
      this._dividaServDesligadoApi = new DividaServDesligadoApi(this._usuarioSso);
    }
    return this._dividaServDesligadoApi;
  }  
  getDividaServDesligadoPagtoApi () {
    if (!this._dividaServDesligadoPagtoApi) {
      this._dividaServDesligadoPagtoApi = new DividaServDesligadoPagtoApi(this._usuarioSso);
    }
    return this._dividaServDesligadoPagtoApi;
  }  
  getCalculoAtuarialApi () {
    if (!this._calculoAtuarialApi) {
      this._calculoAtuarialApi = new CalculoAtuarialApi(this._usuarioSso);
    }
    return this._calculoAtuarialApi;
  }  
  getRelatorioBeneficiariosApi () {
    if (!this._relatorioBeneficiariosApi) {
      this._relatorioBeneficiariosApi = new RelatorioBeneficiariosApi(this._usuarioSso);
    }
    return this._relatorioBeneficiariosApi;
  }  
  getDeclaracaoDeGastosApi () {
    if (!this._declaracaoDeGastosApi) {
      this._declaracaoDeGastosApi = new DeclaracaoDeGastosApi(this._usuarioSso);
    }
    return this._declaracaoDeGastosApi;
  }  
  getReembolsoMedicoApi () {
    if (!this._reembolsoMedicoApi) {
      this._reembolsoMedicoApi = new ReembolsoMedicoApi(this._usuarioSso);
    }
    return this._reembolsoMedicoApi;
  }  
  getAssistenciaOdontoApi () {
    if (!this._assistenciaOdontoApi) {
      this._assistenciaOdontoApi = new AssistenciaOdontoApi(this._usuarioSso);
    }
    return this._assistenciaOdontoApi;
  }  
  getRelatorioReembolsoApi () {
    if (!this._relatorioReembolsoApi) {
      this._relatorioReembolsoApi = new RelatorioReembolsoApi(this._usuarioSso);
    }
    return this._relatorioReembolsoApi;
  }    
  getVigenciaPorteApi () {
    if (!this._vigenciaPorteApi) {
      this._vigenciaPorteApi = new VigenciaPorteApi(this._usuarioSso);
    }
    return this._vigenciaPorteApi;
  }    
}
